import { render, staticRenderFns } from "./sgryzh.vue?vue&type=template&id=00bafdbc&scoped=true&"
import script from "./sgryzh.vue?vue&type=script&lang=js&"
export * from "./sgryzh.vue?vue&type=script&lang=js&"
import style0 from "./sgryzh.vue?vue&type=style&index=0&id=00bafdbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bafdbc",
  null
  
)

export default component.exports